/*
 * Corrects the despatch line on a cached page.
 *
 * The snippet computes the despatch DATE server-side and stamps it on the element as
 * data-despatch-date. A page cached overnight would therefore announce yesterday's answer. This
 * checks that stamp against today (in the SHOP's timezone — the cut-off is a warehouse fact, not
 * the visitor's local midnight) and hides the line if it has gone stale.
 *
 * It deliberately does NOT recompute the date. Doing so would need the holiday and closure lists
 * duplicated into JS, where they would drift from the theme settings the moment a merchant edits
 * one. Hiding a stale line is honest; a second, divergent calculation is not.
 */
(function () {
  var TZ = 'Europe/Paris';

  function shopToday() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      }).format(new Date()); // en-CA gives YYYY-MM-DD
    } catch (e) {
      return null;
    }
  }

  function check(el) {
    var stamped = el.getAttribute('data-despatch-date');
    var today = shopToday();
    if (!stamped || !today) return;

    // The stamped date is always in the future when fresh. If it is today or past, the page was
    // rendered on an earlier day and the named weekday can no longer be trusted.
    if (stamped <= today) {
      el.setAttribute('hidden', '');
      el.textContent = '';
    }
  }

  function init() {
    var nodes = document.querySelectorAll('[data-delivery-cutoff]');
    for (var i = 0; i < nodes.length; i++) check(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
